"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCSSCustomProperty = getCSSCustomProperty;
exports.setCSSCustomProperty = setCSSCustomProperty;
exports.removeCSSCustomProperty = removeCSSCustomProperty;
function getCSSCustomProperty(name, element) {
    if (element === void 0) { element = document.documentElement; }
    var styles = window.getComputedStyle(element);
    return styles.getPropertyValue(name);
}
function setCSSCustomProperty(name, value, element) {
    if (element === void 0) { element = document.documentElement; }
    element.style.setProperty(name, value + '');
}
function removeCSSCustomProperty(name, element) {
    if (element === void 0) { element = document.documentElement; }
    element.style.removeProperty(name);
}
